/* @flow */

import Typenames from './Typenames'
import { ActionTypes, store } from 'store'
import _ from 'lodash'

/**
 * An EsteroAlertLog is the log of checks and triggers activated on the alert.
 * @typedef { Object } EsteroAlertLog
 * @memberof EsteroAlertLogService
 */
export type EsteroAlertLog = {
  id?: String,
  version?: String,
  name: String,
  log: Array<EsteroAlertLogEntry>
}

export type EsteroAlertLogEntry = {
  query?: String,
  active: Boolean,
  message?: String,
  time: Number,
  actions_taken: Array<EsteroAlertLogAction>
}

export type EsteroAlertLogAction = {
  errored: Boolean,
  message?: String
}

/**
 * EsteroAlertLog typename
 * @private
 * @memberof EsteroAlertLogService
 */
const TYPENAME = Typenames.ESTERO_ALERT_LOG

const uniqueConstraints = []

/**
 * Reads an estero alert log, flattening 'descriptive'.
 * @function
 * @memberof EsteroAlertLogService
 *
 * @return { Promise<EsteroAlertLog> } The alert log object.
 */
const read = (id: string): Promise<Object> => {
  return store.dispatch(ActionTypes.GET_BY_ID, { typename: TYPENAME, id: id }).then(alert => {
    return { ...alert }
  })
}

/**
 * Reads all alert logs flattening descriptive.
 * @function
 * @memberof EsteroAlertLogService
 *
 * @return { Observable<Array<EsteroAlert>> } All the alerts.
 */
const readAll = (): Promise<Object> => {
  return store.dispatch(ActionTypes.GET, TYPENAME).then(logs => {
    return _.map(logs, l => {
      return {
        ...l
      }
    })
  })
}

const self = {
  read,
  readAll
}

/**
 * EsteroAlertLog service: CRUD interface for estero alerts log.
 * @module EsteroAlertLogService
 * @namespace EsteroAlertLogService
 * @version 1.0.0
 */
export default self
